import { render } from "./Claims.vue?vue&type=template&id=101e0b8e&scoped=true"
import script from "./Claims.vue?vue&type=script&lang=js"
export * from "./Claims.vue?vue&type=script&lang=js"

import "./Claims.vue?vue&type=style&index=0&id=101e0b8e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-101e0b8e"

export default script